import React from 'react';
import ReactDatePicker from 'react-datepicker';
import { localizedDateFormat } from '../dashboards/eo/revenueUplift/atAGlanceTabUtil';
import './date-picker.scss';

const CustomInput = React.forwardRef(({ label, onClick, style: customStyle }, ref) => (
  <button type="button" className="custom-input" onClick={onClick} ref={ref} style={customStyle}>
    {label}
  </button>
));

CustomInput.displayName = 'CustomInput';

const DatePicker = ({ locale = 'en-US', timezone, formatType = 'full', inputColor, inputFontSize, ...restProps }) => {
  const { selected, value } = restProps;
  const dateValue = value || selected;
  const formattedDate = dateValue ? localizedDateFormat(dateValue, timezone, locale, formatType) : 'Select date';

  const inputStyle = {
    ...(inputColor && { color: inputColor }),
    ...(inputFontSize && { fontSize: inputFontSize }),
  };

  return <ReactDatePicker customInput={<CustomInput label={formattedDate} style={inputStyle} />} {...restProps} />;
};

export default DatePicker;
